<template>
  <DxSelectBox
      ref="productSelectBox"
      v-model="selectedValue"
      :data-source="dataStore"
      :search-enabled="true"
      :min-search-length="2"
      :show-clear-button="true"
      :display-expr="displayExpr"
      :value-expr="valueExpr"
      @value-changed="onValueChanged"
  />
</template>

<script>
import {DxSelectBox} from 'devextreme-vue/select-box';
import CustomStore from 'devextreme/data/custom_store';

export default {
  name: 'AutocompleteRemoteSearch',
  components: {
    DxSelectBox
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    byKeyMethod: {
      type: Function,
      required: true
    },
    searchMethod: {
      type: Function,
      required: true
    },
    displayExpr: {
      type: String,
      default: 'name'
    },
    valueExpr: {
      type: String,
      default: 'uuid'
    },
  },
  data() {
    return {
      selectedValue: null,
      dataStore: null
    };
  },
  created() {
    this.dataStore = new CustomStore({
      key: this.valueExpr,
      byKey: (key) => this.byKeyMethod({ uuid: key }).then(res => res),
      load: (loadOptions) => {
        const search = loadOptions.searchValue || '';
        return this.searchMethod({ name: search }).then(res => res);
      }
    });

    if (this.value) {
      this.loadSelectedItem(this.value);
    }
  },
  watch: {
    value(newVal) {
      if (newVal && newVal !== this.selectedValue) {
        this.loadSelectedItem(newVal);
      }
    }
  },
  methods: {
    loadSelectedItem(uuid) {
      this.byKeyMethod({uuid}).then((res) => {
        this.selectedValue = res[this.valueExpr];
      });
    },
    onValueChanged(e) {
      this.selectedValue = e.value;
      this.$emit('onChange', e.value);
    }
  }
};
</script>
